import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Instagram, MessageCircle, Heart } from 'lucide-react';
import WALink from './WALink';

const IG_URL = "https://www.instagram.com/weavesoflucknow";

export default function Footer() {
  const navigate = useNavigate();

  const scrollTo = (id) => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 300);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#1A2A1A] py-16 border-t border-[#2D4A2D]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-10 mb-12">

          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <div className="text-[9px] font-sans uppercase tracking-[0.4em] text-[#C9A84C] font-medium leading-none mb-1">Weaves of</div>
              <div className="font-serif text-xl text-[#F5F0E8] tracking-[0.12em] uppercase font-light leading-none">Lucknow</div>
            </div>
            <p className="font-sans font-light text-[#F5F0E8]/75 text-xs leading-relaxed mb-5">
              Where every thread tells a story and every stitch carries the charm of India's finest handcraft.
            </p>
            <div className="flex gap-3">
              <a href={IG_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-ig-link"
                className="w-8 h-8 border border-[#2D4A2D] flex items-center justify-center text-[#F5F0E8]/75 hover:text-[#C9A84C] hover:border-[#C9A84C] transition-all duration-200">
                <Instagram size={14} strokeWidth={1.5} />
              </a>
              <WALink source="footer_icon" data-testid="footer-wa-link"
                className="w-8 h-8 border border-[#2D4A2D] flex items-center justify-center text-[#F5F0E8]/75 hover:text-[#C9A84C] hover:border-[#C9A84C] transition-all duration-200">
                <MessageCircle size={14} strokeWidth={1.5} />
              </WALink>
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-sans font-medium text-[#F5F0E8] text-xs uppercase tracking-[0.2em] mb-5">Explore</h4>
            <ul className="space-y-2.5">
              {[['Our Story', 'craft'], ['Lookbook', 'lookbook'], ['Community', 'testimonials']].map(([label, id]) => (
                <li key={id}>
                  <button onClick={() => scrollTo(id)} className="font-sans font-light text-[#F5F0E8]/75 text-sm hover:text-[#C9A84C] transition-colors duration-200 text-left">
                    {label}
                  </button>
                </li>
              ))}
              <li>
                <Link to="/catalogue" className="font-sans font-light text-[#F5F0E8]/75 text-sm hover:text-[#C9A84C] transition-colors duration-200">
                  The Collection
                </Link>
              </li>
            </ul>
          </div>

          {/* Orders */}
          <div>
            <h4 className="font-sans font-medium text-[#F5F0E8] text-xs uppercase tracking-[0.2em] mb-5">Orders</h4>
            <ul className="space-y-2.5">
              <li>
                <button onClick={() => scrollTo('enquiry')} className="font-sans font-light text-[#F5F0E8]/75 text-sm hover:text-[#C9A84C] transition-colors text-left">
                  Bulk Orders
                </button>
              </li>
              <li>
                <button onClick={() => scrollTo('enquiry')} className="font-sans font-light text-[#F5F0E8]/75 text-sm hover:text-[#C9A84C] transition-colors text-left">
                  Custom Design
                </button>
              </li>
              <li>
                <a href="mailto:hello.weavesoflko@gmail.com" className="font-sans font-light text-[#F5F0E8]/75 text-sm hover:text-[#C9A84C] transition-colors">
                  hello.weavesoflko@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4 className="font-sans font-medium text-[#F5F0E8] text-xs uppercase tracking-[0.2em] mb-5">Community</h4>
            <p className="font-sans font-light text-[#F5F0E8]/75 text-xs leading-relaxed mb-5">
              First access to new collections, styling tips aur bohot kuch.
            </p>
            <WALink source="footer_cta" data-testid="footer-community-btn"
              className="inline-flex items-center gap-2 bg-[#2D4A2D] text-[#F5F0E8] px-4 py-2.5 text-xs font-sans font-medium transition-all duration-200 hover:bg-[#C9A84C] hover:text-[#1A2A1A]">
              <MessageCircle size={13} strokeWidth={1.5} />
              Join Community
            </WALink>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-[#2D4A2D]/60 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-sans font-light text-[#F5F0E8]/80 text-xs tracking-wide">
            © 2026 Weaves of Lucknow. All rights reserved.
          </p>
          <p className="font-sans font-light text-[#F5F0E8]/80 text-xs flex items-center gap-1.5">
            Made with <Heart size={11} fill="#C9A84C" stroke="none" /> for modern Indian women
          </p>
        </div>
      </div>
    </footer>
  );
}
